module.exports = __webpack_public_path__ + "files/ac44cbb2f9fd98f2026d847f52c06748.png";